import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/leaflet.css';

delete (L.Icon.Default.prototype as unknown as Record<string, unknown>)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

interface EntryLocationMapProps {
  latitude: number;
  longitude: number;
  locationName?: string;
}

export function EntryLocationMap({ latitude, longitude, locationName }: EntryLocationMapProps) {
  return (
    <div className="card overflow-hidden p-0" style={{ height: 280 }}>
      <MapContainer
        center={[latitude, longitude]}
        zoom={13}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="© OpenStreetMap contributors"
        />
        <Marker position={[latitude, longitude]}>
          {locationName && (
            <Popup>
              <span className="text-sm">{locationName}</span>
            </Popup>
          )}
        </Marker>
      </MapContainer>
    </div>
  );
}
